import { entityIntegrator } from '@/libs/acl/entities'

export default [
  {
    path: '/apps/analytics',
    name: 'apps-analytics',
    component: () => import('@/views/analytics/Analytics.vue'),
    meta: {
      contentClass: 'analytics-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Analytics'
    },
  },
  {
    path: '/apps/analytics/revenue/total-by-directions',
    name: 'apps-analytics-revenue-total-by-directions',
    component: () => import('@/views/analytics/sections/revenue/TotalByDirections.vue'),
    meta: {
      contentClass: 'analytics-revenue-total-by-directions-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by directions'
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/total-by-how-did-know',
    name: 'apps-analytics-patient-appointment-schedule-total-by-how-did-know',
    component: () => import('@/views/analytics/sections/patient-appointment-schedule/TotalByHowDidKnow.vue'),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-total-by-how-did-know-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by how did know'
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/total-by-how-to-contact',
    name: 'apps-analytics-patient-appointment-schedule-total-by-how-to-contact',
    component: () => import('@/views/analytics/sections/patient-appointment-schedule/TotalByHowToContact.vue'),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-total-by-how-to-contact-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by how to contact'
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/doctor/total-by-statuses',
    name: 'apps-analytics-patient-appointment-schedule-doctor-total-by-statuses',
    component: () => import(
      '@/views/analytics/sections/patient-appointment-schedule/TotalByStatusesDoctor.vue'
    ),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-doctor-total-by-statuses-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by statuses (doctors)'
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/operator/total-by-statuses',
    name: 'apps-analytics-patient-appointment-schedule-operator-total-by-statuses',
    component: () => import(
      '@/views/analytics/sections/patient-appointment-schedule/TotalByStatusesOperator.vue'
    ),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-operator-total-by-statuses-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by statuses (operators)'
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/total-by-employees',
    name: 'apps-analytics-patient-appointment-schedule-total-by-employees',
    component: () =>
      import('@/views/analytics/sections/patient-appointment-schedule/total-by-employees/TotalByEmployees.vue'),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-total-by-employees-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by employees',
    },
  },
  {
    path: '/apps/analytics/patient-appointment-schedule/total-by-reviews',
    name: 'apps-analytics-patient-appointment-schedule-total-by-reviews',
    component: () => import(
      '@/views/analytics/sections/patient-appointment-schedule/total-by-reviews/TotalByReviews.vue'
      ),
    meta: {
      contentClass: 'analytics-patient-appointment-schedule-total-by-reviews-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by reviews'
    },
  },
  {
    path: '/apps/analytics/patients/total-by-dental-services',
    name: 'apps-analytics-patients-total-by-dental-services',
    component: () => import('@/views/analytics/sections/patients/TotalByDentalServices.vue'),
    meta: {
      contentClass: 'analytics-patients-total-by-dental-services-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by services'
    },
  },
  {
    path: '/apps/analytics/patients/total-patients-count',
    name: 'apps-analytics-patients-total-patients-count',
    component: () => import('@/views/analytics/sections/patients/total-by-patients-count/TotalPatientsCount.vue'),
    meta: {
      contentClass: 'analytics-patients-total-patients-count-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by patients count'
    },
  },
  {
    path: '/apps/analytics/leads/info',
    name: 'apps-analytics-leads-info',
    component: () => import('@/views/analytics/sections/leads/LeadsInfo.vue'),
    meta: {
      contentClass: 'analytics-leads-info-application',
      resource: entityIntegrator,
      action: 'read',
      title: 'Total by leads'
    },
  },
]
